export const codePaths = {
  EDUCATION: "education",
  DEPARTMENT: "department",
  SECTION: "section",
  TITLE: "title",
  RANK: "rank",
  APPLICANT_STATUS: "applicant-status",
  APPLICANT_TEST_RESULT: "applicant-test-result",
  EMPLOYMENT_STATUS: "employment-status",
  TRAINING_COST: "training-cost",
  Relationship: "relationship",
};

export const securityPaths = {
  PROFILE: "profiles",
  ROLEANDPERMISSION: "roles-permissions",
};

export const FLSAOptions = {
  EXEMPT: "Exempt",
  NON_EXEMPT: "Non Exempt",
};

export const RehireOptions = {
  OK: "OK to rehire",
  NOT_OK: "Do not rehire",
};

export const ImageTypes = {
  Path: "Path",
  Binary: "Binary",
};

export const InputComponentType = {
  TextField: "TextField",
  DatePicker: "DatePicker",
  Dropdown: "Dropdown",
  Checkbox: "Checkbox",
  Radio: "Radio",
  FreeTextDropdown: "FreeTextDropdown",
};

export const customIdPaths = {
  EMPLOYEE_ID: "employee-id",
  COURSE_ID: "course-id",
  CERTIFICATE_ID: "certificate-id",
  PARTICIPANT_ID: "participant-id",
};

export const perNotesOptions = {
  Employees: "Employees",
  Applicants: "Applicants",
};

export const createRecordFor = {
  Employee: "employee",
  Applicant: "applicant",
};

export const PerTagType = {
  Employee: "perPersonnel",
  Applicant: "perApplicant",
  Course: "trainingCourse",
  Participant: "trainingParticipant",
  Certification: "trainingCertification",
};

export const PerPhotoType = {
  Employee: "perPersonnel",
  Applicant: "perApplicant",
};

export const routeToModuleMap = {
  "/employee": { area: "modules", key: "Employees" },
  "/applicants": { area: "modules", key: "Applicants" },
  "/code-settings": { area: "modules", key: "Codes" },
  "/security": { area: "modules", key: "Security" },

  "/training/courses": { area: "training", key: "Courses" },
  "/training/certifications": { area: "training", key: "Certifications" },
  "/training/participants": { area: "training", key: "Participants" },
  "/training/summary": { area: "training", key: "Summary" },
  "/training/mass-update": { area: "training", key: "Mass Update" },

  "/code-settings/department": { area: "codes", key: "Department" },
  "/code-settings/rank": { area: "codes", key: "Rank" },
  "/code-settings/training-cost": { area: "codes", key: "Training Cost" },
  "/code-settings/title": { area: "codes", key: "Title" },
  "/code-settings/section": { area: "codes", key: "Section" },
  "/code-settings/employment-status": {
    area: "codes",
    key: "Employment Status",
  },
  "/code-settings/education": { area: "codes", key: "Education" },
  "/code-settings/applicant-status": { area: "codes", key: "Applicant Status" },
  "/code-settings/applicant-test-result": {
    area: "codes",
    key: "Applicant Test Result",
  },
  "/code-settings/relationship": {
    area: "codes",
    key: "Relationship",
  },
  "/security/profiles": { area: "security", key: "Profiles" },
  "/security/roles-permissions": {
    area: "security",
    key: "Roles And Permissions",
  },
};
